import { AfterViewInit, ChangeDetectionStrategy, Component, output, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
	ComfortPackageComponent,
	ComfortPackageDialogData,
	SelectedSeatsOutput,
} from '@oskar-frontend/comfort-package';
import { Reservation } from '../../reservation.model';
import { ReservationService } from '../../reservation.service';
import { ComfortPackageMode, comfortPackageDataFactory } from '../comfort-package-data.factory';
import { ComfortPackageLogic, refetchNewLayout } from '../comfort-package-logic';

@Component({
	selector: 'app-comfort-package-one-transport',
	templateUrl: './comfort-package-one-transport.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: MatDialogRef,
			deps: [ReservationService],
			useValue: {
				close() {
					return null;
				},
			},
		},
		{
			provide: MAT_DIALOG_DATA,
			deps: [ActivatedRoute],
			useFactory: (activatedRoute: ActivatedRoute): ComfortPackageDialogData => {
				const data = activatedRoute.data['_value'].reservation as Reservation;
				return comfortPackageDataFactory(data, ComfortPackageMode.BOTH);
			},
		},
	],
})
export class ComfortPackageOneTransportComponent extends ComfortPackageLogic implements AfterViewInit {
	confirmSeats = output<{ chosenSeats: SelectedSeatsOutput }>();

	comfortPackageComponent = viewChild<ComfortPackageComponent>('comfortPackage');

	ngAfterViewInit(): void {
		this.listenToTheReservationChanges(ComfortPackageMode.BOTH);

		this.dataChanged$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			refetchNewLayout(this.comfortPackageComponent(), data);
		});
	}
}
